/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Adddocument3Inputs */

const en_coinvestments_dataroom_adddocument3 = /** @type {(inputs: Coinvestments_Dataroom_Adddocument3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add document`)
};

/**
* | output |
* | --- |
* | "Add document" |
*
* @param {Coinvestments_Dataroom_Adddocument3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_adddocument3 = /** @type {((inputs?: Coinvestments_Dataroom_Adddocument3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Adddocument3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_adddocument3(inputs)
});
export { coinvestments_dataroom_adddocument3 as "coInvestments_dataRoom_addDocument" }